import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { IUomForm } from 'partsOld/types';

import { TableWrapper } from './uomsListStyle';

interface IProps {
  onRowClick?;
  tableColumns?;
  uoms?: IUomForm[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?;
}

const UomsListView = ({
  tableColumns,
  uoms,
  onRowClick,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: IProps) => {
  return (
    <TableWrapper>
      <Table
        columns={tableColumns}
        data={uoms}
        name={TableNames.UOMS_LIST}
        alternating={false}
        headerLines={2}
        borderBottom={true}
        onRowClick={onRowClick}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
      />
    </TableWrapper>
  );
};

export default UomsListView;
